import { merge } from "lodash-es";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";
import { SenecNotificationBannerProps } from "src/components/feedback/senec-alert/SenecNotificationBanner";
import { Box, BoxProps, styled } from "@mui/material";

type ThemeWithProps = {
    theme: SenecBaseTheme;
    props: Pick<SenecNotificationBannerProps, "severity" | "sx">;
};

export const FlexBox = styled(Box)<BoxProps>(() => {
    return {
        display: "flex",
    };
});

export const TitleBox = styled(Box)<BoxProps>(() => {
    return {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
    };
});

export const BottomComponentBox = styled(Box)<BoxProps>(() => {
    return {
        position: "sticky",
        bottom: 0,
        zIndex: 2,
    };
});

export const StyledNotificationBanner = styled(Box)<Pick<SenecNotificationBannerProps, "severity" | "sx">>(({
    theme: muiTheme,
    ...props
}) => {
    const theme = muiTheme as SenecBaseTheme;
    const themeWithProps = { theme, props };
    return merge({
        borderRadius: "12px",
        "& .MuiPaper-root": {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: backgroundColor(themeWithProps),
            borderRadius: "12px",
            padding: "24px",
            border: `1px solid ${themeWithProps.theme.palette.neutralGray30.main}`,
            "& #alertIcon > .MuiSvgIcon-root": {
                color: iconColor(themeWithProps),
            },
            "& .MuiBox-root .MuiIconButton-root": {
                width: "24px",
                height: "24px",
                marginLeft: "12px",
                background: "none !important",
            },
            ...(props.sx ?? {}),
        },
        [themeWithProps.theme.breakpoints.down("tablet")]: {
            width: "100%",
        },
    });
});

const backgroundColor = ({ theme, props }: ThemeWithProps) => {
    switch (props.severity) {
        case "info":
            return theme.palette.neutralGray10.main;
        case "success":
            return theme.palette.limeGreen00.main;
        case "warning":
            return theme.palette.sunYellow00.main;
        case "error":
            return theme.palette.tarocco00.main;
    }
};

const iconColor = ({ theme, props }: ThemeWithProps) => {
    switch (props.severity) {
        case "info":
            return "inherit";
        case "error":
            return theme.palette.red.main;
        case "success":
            return "inherit";
        case "warning":
            return theme.palette.yellow.main;
    }
};
